import { useState } from 'react'
import useCreateStore from '../../lib/useCreateStore'
import auctionModalActions from './actions'
import auctionModalSelectors from './selectors'

const initialState = {}

const AuctionModalStore = useCreateStore(() => {
  const [$auctionModal, setAuctionModal] = useState(initialState)

  const actions = auctionModalActions(setAuctionModal)
  const selectors = auctionModalSelectors($auctionModal)

  return { $auctionModal, ...actions, ...selectors }
})

export const useAuctionModal = () => AuctionModalStore()
export const AuctionModalContext = AuctionModalStore.Context
export const AuctionModalProvider = AuctionModalStore.Provider
